import { useEffect, useRef, useState } from 'react'
import Button from '../../../components/atoms/Buttons'
import CloseIcon from '../../../assets/icons/actions/close.svg'

export default function NewFolderModal({ currentPath, onClose, onCreate, creating }) {
  const modalRef = useRef(null)
  const inputRef = useRef(null)
  const [folderName, setFolderName] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    inputRef.current?.focus()
    const handleClickOutside = event => {
      if (modalRef.current && !modalRef.current.contains(event.target) && !creating) {
        onClose()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [onClose, creating])

  const handleSubmit = async event => {
    event.preventDefault()
    const name = folderName.trim()
    if (!name) {
      setError('Folder name is required')
      return
    }
    if (/[/\\]/.test(name)) {
      setError('Folder name cannot contain slashes')
      return
    }
    setError('')
    await onCreate(name)
  }

  return (
    <div>
      <div className="w-full h-full fixed top-0 left-0 z-40 bg-[#000] opacity-60"></div>

      <div
        ref={modalRef}
        className="w-[340px] sm:w-[480px] max-w-[calc(100vw-1.5rem)] rounded-[26px] bg-[#fff] p-8 shadow-2xl z-50 fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 font-montserrat"
      >
        <div
          onClick={!creating ? onClose : undefined}
          className="absolute top-5 right-5"
        >
          <img
            src={CloseIcon}
            alt="Close"
            className={`w-3 h-3 sm:w-4 sm:h-4 ${creating ? 'cursor-not-allowed' : 'cursor-pointer'}`}
          />
        </div>

        <h4 className="text-lg font-semibold text-gray-800 m-0 mb-1">New Folder</h4>
        <p className="text-sm text-gray-500 m-0 mb-4 truncate" title={currentPath}>
          Will be created in: <span className="font-medium">{currentPath}</span>
        </p>

        <form onSubmit={handleSubmit}>
          <input
            ref={inputRef}
            type="text"
            value={folderName}
            onChange={e => setFolderName(e.target.value)}
            placeholder="Folder name"
            disabled={creating}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#2b364b]"
          />
          {error && <p className="text-red-500 text-sm mt-1 mb-0">{error}</p>}

          <div className="flex justify-end gap-2 mt-6">
            <Button
              type="button"
              primaryOutline
              onClick={onClose}
              disabled={creating}
              className="create-saddle-btn !w-auto px-6 cursor-pointer"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              primary
              loading={creating}
              className="create-saddle-btn !w-auto px-6 cursor-pointer"
            >
              Create
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
}
